import { NavBar, Collapse } from 'bootstrap';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import isTouchDevice from './utils/isTouchDevice';
import getScrollbarWidth from './utils/getScrollbarWidth';
import openExternalInNewTab from './utils/openExternalInNewTab';
// import Splide from '@splidejs/splide';
// import { EventInterface } from '@splidejs/splide';

import HeaderNav from './components/header-nav';
import Hashbar from './components/hashbar';
import CardSlider from './blocks/card-slider';
import CardGrid from './blocks/card-grid';
import LandingPageHero from './blocks/landing-page-hero';
import MainHero from './blocks/main-hero';
import MeetingArchive from './blocks/meeting-archive';

import Project from './components/project';

HeaderNav();
Hashbar();
CardSlider();
CardGrid();
LandingPageHero();
MainHero();
MeetingArchive();
Project();

if (isTouchDevice()) {
  document.body.classList.add('is-touch-device');
}
gsap.registerPlugin(ScrollTrigger);

document.body.style.setProperty(
  '--scrollbar-width',
  `${getScrollbarWidth()}px`,
);

openExternalInNewTab();